import React, { useState } from 'react';
import '../../style/home.css';
// import SendCommentry from '../../Pages/Access Control/sendcommentry';
import {Dialog,DialogContent} from '@mui/material';

const TelegramWidget = () => {
  const [showSendCommentry, setShowSendCommentry] = useState(false);

  // console.log("showSendCommentry",showSendCommentry)
  const handleClick = () => {
    // console.log("showSendCommentry",showSendCommentry)
    setShowSendCommentry(!showSendCommentry);
  };


  return (
    <div className="telegram-widget-container">
      <div className="telegram-widget">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg"
          alt="Telegram Icon"
          className="telegram-icon"
          onClick={handleClick}
        />
      </div>
     

       <Dialog
        open={showSendCommentry}
        onClose={handleClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
      
        <DialogContent>
        <div className="send-commentry-box">
          {/* <SendCommentry /> */}
        </div>
        </DialogContent>
     
      </Dialog>
    </div>
  );
};

export default TelegramWidget;
